const BYTES_TO_MEBIBYTES = 1048576

export const FileSizeCalculator = {
  bytesToMebibytes: (bytes: number): number => (
    bytes / BYTES_TO_MEBIBYTES
  ),

  mebibytesToBytes: (mebibytes: number): number => (
    mebibytes * BYTES_TO_MEBIBYTES
  )
}

export default FileSizeCalculator
